import { Box, IconButton, Menu, MenuItem } from '@material-ui/core';
import React from 'react';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { Toolbar } from 'views/ProductDetail/components';
import clsx from 'clsx';
import classes from './MoreActions.module.scss';

const MoreActions = ({ className, renderAnchor, actions = [] }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Box className={clsx(classes.moreActions, className)}>
      {renderAnchor ? (
        renderAnchor({ handleClick })
      ) : (
        <IconButton
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            handleClick(event);
          }}
          aria-label='more-action'>
          <MoreHorizIcon />
        </IconButton>
      )}

      <Menu
        className={classes.menu}
        id='customized-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}>
        {(actions || []).map(({ danger, ...action }, index) => {
          return (
            <MenuItem
              key={action.key || index}
              button={false}
              className={danger ? classes.menuItem__danger : null}
              onClick={(event) => {
                handleClose();
                event.stopPropagation();
                if (action.onClick) {
                  // if ActionsCell do func, here will call second time
                }
              }}>
              <Toolbar.Action {...action} />
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
};

export default MoreActions;
